import { User } from "firebase/auth";
import { Header } from "./Header";
import { Main } from "./Main";
import { useTournamentStore } from "../app/hooks";

type UserProps = {
  user: User;
};

export const Authenticated = ({ user }: UserProps) => {
  useTournamentStore();

  return (
    <div className="App">
      <header className="App-header">
        <Header user={user} />
      </header>
      <main className="App-body">
        <Main />
      </main>
      <footer className="App-footer"></footer>
    </div>
  );
};
